// import jQuery from 'CommonScripts/jquery-1.10.2';
import isPageEditor from "GlobalsScript/is-page-editor";

(function (window, document, $) {
     
    $(document).ready(function () {

        /* Add read more dropdown page functionality */
        if ($('.read-more-block').length > 0 && window.innerWidth >= 768) {
            ; (function () {

                if (isPageEditor() == false) {

                    var Accessory = {
                        dom: {
                            accessory: function () { return $('.read-more-block') },
                            readMore: $('.read-more-block .read-more-toggle'),
                            readMoreAnchor: $('.read-more-block .read-more-toggle a'),
                            readMoreOverlay: $('html'),
                            readMoreWrapper: $('.read-more-wrapper'),
                            mainWrapper: document.querySelector('#main > main')
                        },
                        set: {
                            speed: 500,
                            animation: 'linear',
                            oldAccessory: null,
                            newAccessory: null,
                            sliding: false,
                            activeClass: 'read-more-open',
                            opened: false,
                            activeWrapper: 'read-more-activewrapper'
                        },
                        fn: {
                            showMoreInfo: function () {
                                /* Always hide any accessory that is opened */
                                $fn.hideMoreInfo($set.oldAccessory);

                                /* Set the height of the article, since it's immediate child will be positioned absolutely */
                                $set.newAccessory.height($set.newAccessory.height());

                                /* Set the active class on the new accessory that needs opening */
                                $set.newAccessory.addClass($set.activeClass);
                                $set.newAccessory.closest('article').addClass($set.activeClass);
                                $set.newAccessory.closest('section').addClass($set.activeClass);
                                $set.newAccessory.find('.read-more-wrapper').addClass($set.activeWrapper);
                                $('.inspiration-read-more').css('z-index', 1); // the expander goes over the open read more spot when not intended

                                /* Show overflow when the section is at the bottom of the page */
                                $dom.mainWrapper.style.setProperty('overflow', 'visible', 'important');
                            },
                            hideMoreInfo: function (item) {
                                item.removeClass($set.activeClass);
                                item.closest('article').removeClass($set.activeClass);
                                item.closest('section').removeClass($set.activeClass);
                                item.find('.read-more-wrapper').removeClass($set.activeWrapper);
                                $('.inspiration-read-more').css('z-index', 3);
                                $dom.mainWrapper.style.removeProperty('overflow');
                            }
                        }
                    },
                    /* Add quick access variables to be used in local function
                    * Keep main variable name in case it needs to be shared with other JS files
                    */
                    $dom = Accessory.dom,
                    $set = Accessory.set,
                    $fn = Accessory.fn;


                    /* Click anywhere (except inside active read-more element) closes active read-more  */
                    $dom.readMoreOverlay.on({
                        click: function () {
                            if ($set.newAccessory != null) {
                                $set.opened = false;
                                $fn.hideMoreInfo($set.newAccessory);
                            }
                        }
                    });
                    /* Click on active read-more element prevents from closing it */
                    $dom.readMoreWrapper.on({
                        click: function (event) {
                            event.stopPropagation();

                            if (!$(this).hasClass($set.activeWrapper)) {
                                $fn.hideMoreInfo($set.newAccessory);
                            }
                        }
                    });
                    /* Show more information about the accessory when clicking the Read More button */
                    $dom.readMore.on({
                        click: function (event) {
                            event.stopPropagation();
                            /* Set the new accessory */
                            $set.newAccessory = $(this).closest('.read-more-block');
                            $set.oldAccessory = $dom.accessory().filter('.' + $set.activeClass);                            

                            /* Hide the current accessory if it's set to active */
                            if ($set.newAccessory.hasClass($set.activeClass)) {
                                $fn.hideMoreInfo($set.oldAccessory);
                            }

                            /* Only show the new accessory when it's different than the old accessory */
                            if ($set.newAccessory.html() != $set.oldAccessory.html()) {
                                $fn.showMoreInfo();
                            }
                        }
                    });

                    /* Prevent clicking on the <a> elements on the Read More buttons */
                    $dom.readMoreAnchor.on({
                        click: function (e) {
                            e.preventDefault();
                        }
                    });
                }
            })();
        }

    });
})(window, document, jQuery);